export const Functions = {
  create: false,
  delete: true,
  detail: true,
  search: true,
};

export const PageName = '资产转移登记';
